/* eslint-disable no-unused-vars */
import React, { useCallback } from 'react';
import Modal from './index';
import style from './modal.module.scss';
import Button from 'controls/buttons/submit';
import {
  useRegisterKeyHandler,
  useUniqueKeyHandler,
} from 'hooks/useKeyHandler';

export default function SuccessModal({
  successText,
  onClose,
}: {
  successText: string;
  onClose: () => void;
}) {
  const keyHandlerId = useUniqueKeyHandler();
  const keyHandler = useCallback(
    (e: KeyboardEvent) => {
      switch (e.code) {
        case 'Enter':
          e.preventDefault();
          e.stopPropagation();
          onClose();
          break;
      }
    },
    [onClose]
  );
  useRegisterKeyHandler({
    handler: keyHandler,
    id: keyHandlerId,
  });

  return (
    <Modal
      open={true}
      onClose={onClose}
      innerSX={{
        borderWidth: 2,
        borderColor: 'success.main',
        borderStyle: 'solid',
      }}
    >
      <div className={style.success}>
        {successText}
        <div className={style.buttons}>
          <Button className={style.close} onClick={onClose}>
            Продолжить
          </Button>
        </div>
      </div>
    </Modal>
  );
}
